// material-ui
import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';

// styles
const LoaderWrapper = styled('div')({
  position: 'fixed',
  bottom: 0,
  left: 0,
  zIndex: 1301,
  width: '100%',
});

// ==============================|| LOADER ||============================== //

const MobileLoader = () => (
  <LoaderWrapper>
    <LinearProgress color="success" />
  </LoaderWrapper>
);

export default MobileLoader;
